import React from 'react';

const CustomLoadingCellRenderer = () => {
  return <div className="ag-custom-loading-cell"></div>;
};

CustomLoadingCellRenderer.displayName = 'CustomLoadingCellRenderer';
export { CustomLoadingCellRenderer };
